'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import type { CtaButtonBottomProps } from '@/app/components/sections/special-offer/detail/search-dealer-contact/types';
import { SPECIAL_OFFER_DATA_TEST, SPECIAL_OFFER_EVENT_NAME } from '@/app/components/sections/special-offer/tracking';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export const CtaButtonBottom = t0 => {
  const $ = _c(13);
  const {
    title: t1,
    isVisible: t2,
    onClick
  } = t0;
  const title = t1 === undefined ? "\u0E19\u0E31\u0E14\u0E2B\u0E21\u0E32\u0E22\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C" : t1;
  const isVisible = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== isVisible) {
    t3 = cn("property-translate ease-curve fixed right-0 bottom-0 left-0 z-30 bg-white px-6 py-4 duration-300", "before:absolute before:inset-0 before:rotate-180 before:shadow-xl", "lg:hidden", {
      "translate-y-full": isVisible
    });
    $[0] = isVisible;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "cta-sticky-bottom"
    });
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = createDataAttributes({
      test: "cta-button-bottom"
    });
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== title) {
    t6 = createDataGA({
      eventName: SPECIAL_OFFER_EVENT_NAME,
      group: SPECIAL_OFFER_DATA_TEST.BUTTON_BOOKING,
      click: true,
      text: title
    });
    $[4] = title;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onClick || $[7] !== t6 || $[8] !== title) {
    t7 = <Button variant="primary" color="red" width="full" onClick={onClick} {...t5} {...t6}>{title}</Button>;
    $[6] = onClick;
    $[7] = t6;
    $[8] = title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t7) {
    t8 = <aside className={t3} {...t4}>{t7}</aside>;
    $[10] = t3;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};